import axios from 'axios';
import 'leaflet/dist/leaflet.css';
import React, { useEffect, useState } from 'react';
import { CircleMarker, MapContainer, Popup, TileLayer } from 'react-leaflet';
import { EVENTS_FOR_MLT } from '../ApiDetails.js';

const EventMltMap = ({ filters }) => {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const userLocation = { lat: 51.505, lng: -0.09 }; // Replace with the actual user's location
    const bounds = [
        [-85, -180], // Southwest corner
        [85, 180], // Northeast corner
    ];

    useEffect(() => {
        const fetchEvents = async () => {
            try {
                await axios.get(EVENTS_FOR_MLT)
                    .then(response => setEvents(response.data))
                    .catch(() => {
                        throw new Error('Network response was not ok');
                    });
            } catch (error) {
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchEvents();
    }, []);

    const getFillColor = (event) => {
        if (filters.UpComingEvents && event.category.includes("Upcoming")) {
            return 'lime';
        }
        if (filters.EventsWithNewComments && event.category.includes('New Comments')) {
            return 'yellow';
        }
        if (filters.EventSiteforOthers && event.category.includes('SiteCodeOFF')) {
            return 'red';
        }
        return null; // Exclude events that don't match any specific filter
    };

    const filteredEvents = events.filter(event => {
        const fillColor = getFillColor(event);// Filter by selected region
        return fillColor !== null && event.lat !== 0 && event.lng !== 0;
    });

    if (loading) return <p>Loading events...</p>;
    if (error) return <p>Error fetching events: {error}</p>;

    return (
        <MapContainer
            center={userLocation}
            zoom={2}
            maxZoom={10}
            minZoom={1}
            maxBounds={bounds}
            style={{ height: '100%' }}
        >
            <TileLayer
                url="http://services.arcgisonline.com/arcgis/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}"
            />
            {filteredEvents.map(event => ( ((event.lat !== 0) || (event.lng !== 0 )) ? (
                <CircleMarker
                    key={event.id}
                    center={[event.lat, event.lng]}
                    color={getFillColor(event)}
                    fillColor={getFillColor(event)}
                    fillOpacity={1}
                    radius={10}
                    className="custom-circle-marker" // Applying the CSS class for the border
                >
                    <Popup>{event.name}</Popup>
                </CircleMarker>
            ) : ""))}
        </MapContainer>
    );
};

export default EventMltMap;